import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { FC, useRef } from 'react'

interface Coupon {
    id: string;
    couponName: string;
    couponIcon: string;
    couponValue: string;
    status: string;
    issuedTo: string[];
    couponDesc: string;
    redeemCode: string;
}

interface User {
    id: string;
    name: string;
    productionIds: number[];
    registryId: string
}

interface ProductionReceiptProps {
    user: any;
}

const Rewards: React.FC<ProductionReceiptProps> = ({ user }) => {
    const poiDoc = user?.kycDocument?.find((doc) => doc.docType === 'POI')?.docUrl;
    const [coupons, setCoupons] = useState<Coupon[]>([]);

    const getTokenFromStorage = () => {
        const authData = localStorage.getItem('kt-auth-react-v')
        if (authData) {
            try {
                const parsedData = JSON.parse(authData)
                return parsedData.data?.franchiseId
            } catch (e) {
                console.error('Error parsing auth data:', e)
            }
        }
        return null
    }

    useEffect(() => {
        const franchiseId = getTokenFromStorage();

        if (franchiseId && user?.id) {
            fetch(`${process.env.REACT_APP_BASE_API_URL}coupons/franchisee/${franchiseId}`)
                .then(res => res.json())
                .then(data => {
                    const couponsArray = Array.isArray(data) ? data : data.data || [];
                    console.log("Coupons array:", couponsArray);

                    const issuedCoupons = couponsArray.filter((coupon: any) =>
                        coupon.issuedTo && Array.isArray(coupon.issuedTo) && coupon.issuedTo.includes(user.id)
                    );

                    console.log("Filtered coupons:", issuedCoupons);
                    setCoupons(issuedCoupons);
                })
                .catch(err => console.error('Error fetching coupons:', err));
        }
    }, [user?.id]);

    return (
        <>
            <div style={{ flex: 1, padding: '24px' }}>
                {/* Profile Section */}
                <div style={{ display: 'flex', alignItems: 'center', gap: '24px', marginBottom: '32px', paddingBottom: '24px', borderBottom: '2px solid #e8e8e8' }}>
                    <div style={{
                        width: '80px',
                        height: '80px',
                        borderRadius: '50%',
                        backgroundColor: '#f8f8f8',
                        overflow: 'hidden',
                        flexShrink: 0,
                        border: '3px solid #e0e0e0',
                        boxShadow: '0 4px 12px rgba(0,0,0,0.08)'
                    }}>
                        <img
                            src={poiDoc}
                            alt="Profile"
                            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                        />
                    </div>
                    <div>
                        <p style={{ margin: '0', fontSize: '20px', fontWeight: '700', color: '#333' }}>
                            {user?.personalDetails?.name}
                        </p>
                    </div>
                </div>

                {/* Cards Section */}
                <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                    <div style={{ display: 'flex', gap: '16px' }}>
                        <div style={{
                            flex: 1,
                            backgroundColor: '#ffffff',
                            border: '1px solid #e0e0e0',
                            borderRadius: '10px',
                            padding: '20px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            height: '80px',
                            boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
                            transition: 'all 0.3s ease',
                            cursor: 'pointer'
                        }}>
                            <div style={{ fontSize: '15px', fontWeight: '600', color: '#666' }}>Lifetime earning</div>
                            <div style={{ fontSize: '20px', fontWeight: '700', color: '#7239ea' }}>
                                {Math.round(user?.totalEarnings)}
                            </div>
                        </div>
                        <div style={{
                            flex: 1,
                            backgroundColor: '#ffffff',
                            border: '1px solid #e0e0e0',
                            borderRadius: '10px',
                            padding: '20px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            height: '80px',
                            boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
                            transition: 'all 0.3s ease',
                            cursor: 'pointer'
                        }}>
                            <div style={{ fontSize: '15px', fontWeight: '600', color: '#666' }}>Lifetime paid</div>
                            <div style={{ fontSize: '20px', fontWeight: '700', color: '#ffc700' }}>
                                {Math.round(user?.totalPaid)}
                            </div>
                        </div>
                    </div>
                    <div style={{ display: 'flex', gap: '16px' }}>
                        <div style={{
                            flex: 1,
                            backgroundColor: '#ffffff',
                            border: '1px solid #e0e0e0',
                            borderRadius: '10px',
                            padding: '20px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            height: '80px',
                            boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
                            transition: 'all 0.3s ease',
                            cursor: 'pointer'
                        }}>
                            <div style={{ fontSize: '15px', fontWeight: '600', color: '#666' }}>2025 Earning</div>
                            <div style={{ fontSize: '20px', fontWeight: '700', color: '#3e97ff' }}>
                                {Math.round(user?.currentYearEarnings)}
                            </div>
                        </div>
                        <div style={{
                            flex: 1,
                            backgroundColor: '#ffffff',
                            border: '1px solid #e0e0e0',
                            borderRadius: '10px',
                            padding: '20px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            height: '80px',
                            boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
                            transition: 'all 0.3s ease',
                            cursor: 'pointer'
                        }}>
                            <div style={{ fontSize: '15px', fontWeight: '600', color: '#666' }}>2025 Paid</div>
                            <div style={{ fontSize: '20px', fontWeight: '700', color: '#7239ea' }}>
                                {Math.round(user?.currentYearPaid)}
                            </div>
                        </div>
                    </div>
                </div>

                {/* Coupons Section */}
                <p style={{ fontSize: '18px', fontWeight: '700', color: '#333', marginTop: '32px', marginBottom: '16px' }}>
                    Coupons earned
                </p>

                <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                    {coupons.map((coupon: Coupon) => (
                        <div key={coupon.id} style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '16px',
                            backgroundColor: '#ffffff',
                            border: '1px solid #e0e0e0',
                            borderRadius: '10px',
                            padding: '16px',
                            boxShadow: '0 2px 8px rgba(0,0,0,0.04)'
                        }}>
                            <div style={{
                                width: '60px',
                                height: '60px',
                                borderRadius: '50%',
                                backgroundColor: '#f8f8f8',
                                overflow: 'hidden',
                                flexShrink: 0,
                                border: '2px solid #e0e0e0'
                            }}>
                                <img
                                    src={coupon.couponIcon}
                                    alt={coupon.couponName}
                                    style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                />
                            </div>
                            <div style={{ flex: 1 }}>
                                <p style={{ margin: '0', fontSize: '16px', fontWeight: '600', color: '#333' }}>
                                    {coupon.couponName}
                                </p>
                                <p style={{ margin: '4px 0 0 0', fontSize: '14px', color: '#999' }}>
                                    {coupon.couponValue}
                                </p>
                            </div>
                            <div className={`badge badge-light-${coupon.status === 'ISSUED' ? 'success' : 'warning'} fs-7 fw-bold`}>
                                {coupon.status}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </>
    );
};

export default Rewards;